module.exports = __webpack_public_path__ + "img/switzerland-liver-cancer-female.5c0207e9.png";